import { render, staticRenderFns } from "./InAppBillingSettings.vue?vue&type=template&id=5172235a"
import script from "./InAppBillingSettings.vue?vue&type=script&lang=js"
export * from "./InAppBillingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports